export default __webpack_public_path__ + "static/media/success-concierge.13f8b8bc.png";